import { useCallback } from "react";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import Button from "@portal/components/atoms/v2/buttons/button";
import { ISavingsFooterProps } from "../types";

export const Footer = ({ router, isDefaultLanguage, buttonDisabled, onClick, isLoading }: ISavingsFooterProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  const OnSecondaryButtonClick = useCallback(() => {
    router.push(`/robot/15`);
  }, [router]);

  return (
    <div className="flex flex-col mt-1 mb-5">
      <div className="flex  mt-5 justify-between">
        <Button onClick={OnSecondaryButtonClick} text={texts.BUTTON_BACK} />
        <Button
          loading={isLoading ? 1 : 0}
          onClick={onClick}
          text={isLoading ? "" : texts.BUTTON_NEXT}
          primary
          wide
          disabled={buttonDisabled}
        />
      </div>
    </div>
  );
};
